<template lang="pug">
  .reports-wrapper
    .reports-table
      v-card
        .reports-table__header
          .reports-table__row.reports-table__row--header.reports-table__row--small
            .reports-table__column {{ 'base.date' | translate }}
            .reports-table__column {{ 'base.status' | translate }}
            .reports-table__column {{ 'base.ration' | translate }}
            .reports-table__column {{ 'base.recipe' | translate }}
            .reports-table__column {{ 'base.plan' | translate }} [{{ 'units.kg' | translate }}]
            .reports-table__column {{ 'base.fact' | translate }} [{{ 'units.kg' | translate }}]
            .reports-table__column {{ 'base.unloaded' | translate }} [{{ 'units.kg' | translate }}]
            .reports-table__column {{ 'base.deviation' | translate }} [{{ 'units.kg' | translate }}/%]
            .reports-table__column {{ 'base.start_time' | translate }}
            .reports-table__column {{ 'base.duration' | translate }} [+/-]
      v-table-body(
        v-if="!loading"
        outside-table
        gap
        :empty="!reports.length")
        reports-table-row(
          v-for="item in reports"
          :key="item.id"
          :item="item")
      reports-table-row-skeleton(
        v-else
        :count="10")
      template(
        v-if="!loading && showPagination")
        v-paginate(
          v-model="page"
          :page-count="pageCount"
          :click-handler="pageChangeHandler")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import paginationMixin from '@/mixins/pagination.mixin'
import ReportsTableRow from './ReportsTableRow'
import ReportsTableRowSkeleton from './ReportsTableRowSkeleton'

export default {
  name: 'ReportsTable',
  mixins: [paginationMixin],

  components: {
    ReportsTableRow,
    ReportsTableRowSkeleton
  },

  mounted () {
    this.setupPagination(this.fetchReports)
  },

  computed: {
    ...mapGetters([
      'reports',
      'reportsFilters'
    ]),

    filters () {
      return this.reportsFilters
    }
  },

  methods: {
    ...mapActions(['fetchReports'])
  },

  watch: {
    filters () {
      this.page = 1
      this.loadData()
    }
  }
}
</script>

<style lang="scss">
  @import '@/sass/abstracts/_variables';

  .reports-table {
    font-size: 1.5rem;
    line-height: 1.8rem;

    &__row {
      position: relative;
      padding: 1.5rem;
      display: flex;
      align-items: center;

      &--small {
        padding: .8rem 1.5rem;
      }

      &--header {
        .reports-table {
          &__column {
            color: $color-gray;
          }
        }
      }

      &--body {
        .reports-table {
          &__column {
            // text-overflow: ellipsis;
            // overflow: hidden;
            // white-space: nowrap;
            max-width: 20rem;
            overflow-wrap: anywhere;
          }
        }
      }
    }

    &__header {
      margin-bottom: 1.5rem;
    }

    &__column {
      font-size: 1.3rem;
      padding-right: 2.4rem;
      &:nth-child(1) {
        flex: 1 1 12%;
      }

      &:nth-child(2) {
        flex: 1 1 12.85%;
      }

      &:nth-child(3) {
        flex: 1 1 12%;
      }

      &:nth-child(4) {
        flex: 1 1 14%;
      }

      &:nth-child(5) {
        flex: 1 1 9%;
      }

      &:nth-child(6) {
        flex: 1 1 8.5%;
      }

      &:nth-child(7) {
        flex: 1 1 14%;
      }

      &:nth-child(8) {
        flex: 1 1 10%;
      }

      &:nth-child(9) {
        flex: 1 1 10%;
      }

      &:nth-child(10) {
        flex: 1 1 11%;
      }

      &.batch {
        flex: 1 1 10% !important;
        &:nth-child(2) {
          flex: 1 1 5% !important;
        }
        &:nth-child(3) {
          flex: 1 1 15% !important;
        }
      }

    }

    &__list {
      position: relative;
      padding: 1.35rem 5.6rem;
      display: flex;
      max-width: 37rem;
      width: 100%;

      &::after {
        content: '';
        position: absolute;
        background-color: $color-gray-light-2;
        height: .1rem;
        width: 55%;
        bottom: 0;
      }

      &:nth-child(2) {
        &::before {
          content: '';
          position: absolute;
          background-color: $color-gray-light-2;
          height: .1rem;
          max-width: 78.5rem;
          width: 220%;
          top: 0;
          left: 1rem;
        }
      }

      &:last-child {
        padding-bottom: 2.9rem;

        &::after {
          bottom: 1.5rem;
        }
      }
    }

    &__list-empty {
      padding: 1.5rem 1.8rem;
      text-align: center;
      border-top: 1px solid $table-border-color;
    }

    &__item {
      &:first-child {
        margin-right: auto;
      }

      &:last-child {
        margin-left: 3rem;
      }
    }
  }
</style>
